export const locales = ['en-US', 'en-PS', 'fr_FR', 'de_DE', 'ja_JA'] as const;

export type Locales = typeof locales[number];

export type DynamicFileImport = Promise<{ default: Record<string, string> }>;
